import { ConfigurationDto, ConfigurationKey } from "@intelligems/ig-types";

import { useGetOrg } from "../organizations/get-organization";

export const useConfiguration = <T = any>(
  key: Lowercase<ConfigurationKey>
): ConfigurationDto | undefined => {
  const org = useGetOrg();
  const found = org.data.org.configurations?.find(
    (config: ConfigurationDto) => config.key === key
  );
  if (found && found.value !== undefined) {
    return found;
  }
};
